export default __webpack_public_path__ + "static/media/new2.0a3cc702.webp";